import { CreateAppointmentQueueData } from './CreateAppointmentQueueMapper.types'

class CreateAppointmentQueueMapper {
  toPersistence(domainData: CreateAppointmentQueueData) {
    return {
      idClinica: domainData?.clinic?.id,
      idEspecialidade: domainData?.specialty?.id,
      idPaciente: domainData?.patient?.patientId,
      idProfissional: domainData?.professional?.id,
      tipoProfissional: domainData?.professionalType?.key,
    }
  }
}

export default new CreateAppointmentQueueMapper()
